import { render, staticRenderFns } from "./AcknowledgementPage.vue?vue&type=template&id=73bba796&scoped=true&"
import script from "./AcknowledgementPage.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementPage.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgementPage.vue?vue&type=style&index=0&id=73bba796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bba796",
  null
  
)

export default component.exports